module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/168.6fd007f7.png";